var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.visible)?_c('div',{staticClass:"run__line",style:({
      background: _vm.background,
    })},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"b-marquee",style:({
          color: _vm.color,
          fontSize: (_vm.font_size || 12) + 'px',
        })},[_c('div',{staticClass:"b-marquee__text",style:(`animation: animMarqueeRtl ${_vm.speed}s linear infinite`)},[_vm._v(" "+_vm._s(_vm.text)+" ")])])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }